
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.626 10.8a.938.938 0 01-.938-.937V8.138a4.7 4.7 0 00-1.541-3.477 4.636 4.636 0 00-3.606-1.19 5.04 5.04 0 00-4.228 4.9v1.217a.938.938 0 01-1.875 0V8.375a6.91 6.91 0 015.925-6.771 6.563 6.563 0 017.2 6.533v1.726a.938.938 0 01-.937.937z","fill":"#8d98aa","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M18.75 28.438h-7.5c-2.562 0-4.365-.51-5.512-1.558a5.64 5.64 0 01-1.607-3.733l-.937-7.493v-.013a5.787 5.787 0 011.108-4.718C5.423 9.672 7.287 9.063 10 9.063h10c2.713 0 4.576.609 5.7 1.86a5.787 5.787 0 011.109 4.718v.013l-.937 7.492a5.64 5.64 0 01-1.607 3.734c-1.151 1.048-2.954 1.558-5.515 1.558zM5.056 15.428l.937 7.493v.016a3.714 3.714 0 001.008 2.558c.787.718 2.173 1.068 4.249 1.068h7.5c2.072 0 3.461-.349 4.247-1.067a3.714 3.714 0 001.008-2.558v-.016l.937-7.493a4.029 4.029 0 00-.643-3.254c-.735-.82-2.181-1.236-4.3-1.236h-10c-2.119 0-3.566.416-4.3 1.236a4.029 4.029 0 00-.643 3.253z","fill":"#8d98aa"}}),_c('path',{attrs:{"data-name":"Vector","d":"M19.381 16.25h-.011a1.25 1.25 0 110-2.5h.011a1.25 1.25 0 110 2.5zM10.63 16.25h-.011a1.25 1.25 0 110-2.5h.011a1.25 1.25 0 110 2.5z","fill":"#8d98aa","opacity":".4"}})])
          )
        }
      }
    